import React from 'react'
import PropTypes from 'prop-types'

import { getBloodPressureTresholdValue } from '@util/tresholdUtil'
import { statusColors } from '@generators/tresholdConstants'
import { Status } from './Status'
import { Box } from './Box'
import { TresholdDisplay } from './ThresholdDisplay'

export const BloodPressureStatus = ({ syst, diast, type }) => {
  const category = getBloodPressureTresholdValue(syst, diast)

  return (
    <div
      style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
    >
      <div>
        <Status
          text={category}
          backgroundColor={`${statusColors[category]}1A`}
          textColor={statusColors[category]}
          style={{ marginRight: 24 }}
        />
      </div>
      <Box width={223.5}>
        <TresholdDisplay syst={syst} diast={diast} type={type} />
      </Box>
    </div>
  )
}

BloodPressureStatus.propTypes = {
  syst: PropTypes.number.isRequired,
  diast: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
}
